import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Home from "./Home";
import Header from "./Header";
import Checkout from "./Checkout";
import Login from './Login';
import { auth } from './firebase';
import { useStateValue } from './StateProvider';
import Payment from './Payment';
import {loadStripe} from "@stripe/stripe-js";
import {Elements} from "@stripe/react-stripe-js";
import Orders from './Orders';

const promise=loadStripe('pk_test_51Iaw9nSBU6zPrMpp00KfTPdYALE8Pxx2aSixnORJOga18EDXn6lKsnaOqSftfzPckT5GrZmNOyzdQrUUaJOyA5an00QzuvgNi9');
function App() {
  const [{},dispatch]=useStateValue();
  useEffect(()=>{

    auth.onAuthStateChanged(authUser =>{
      console.log('THE USER IS>>>',authUser);

      if(authUser){
        dispatch({
          type: 'SET_USER',
          user:authUser
        })
      }else{
        dispatch({
          type:'SET_USER',
          user: null
        })
      }
    })
  },[])
  return (
    
      <Router>
      <div className="app">
        
      <Switch>
      <Route path="/orders">
        <Header/>
          <Orders/>
        </Route>
        <Route path="/login">
          <Login/>
        </Route>
        <Route path="/checkout">
        <Header/>
          <Checkout/>
        </Route>
        <Route path="/payment">
        <Header/>
        <Elements stripe={promise}>
          <Payment/>
        </Elements>
        </Route>
        <Route path="/">
        <Header/>
        <Home />
        </Route>
      </Switch>
      </div>
    </Router>
    
  );
}

export default App;
